import { AnyAction } from 'redux';
import { LOGOUT_SUCCESS } from '../types/auth';
import { RESET_PASSWORD_FOR_USER_SUCCESS, VERIFY_OTP_FOR_REF_ID_SUCCESS } from '../types/user';

const initState: Partial<{ token: string | null }> = {
  token: null,
};
function resetUserReducer(state = initState, action: AnyAction): Partial<{ token: string | null }> {
  switch (action.type) {
    case VERIFY_OTP_FOR_REF_ID_SUCCESS: {
      return {
        ...state,
        ...action.body,
      };
    }
    case RESET_PASSWORD_FOR_USER_SUCCESS:
    case LOGOUT_SUCCESS: {
      return { ...initState };
    }
    default:
      return state;
  }
}

export default resetUserReducer;
